export { default } from "./MiniLabel";
